import React from "react";

function TermsAndConditions() {
  return (
    <div className="mx-auto max-w-3xl px-6 py-14">
      <h2 className="mb-4 text-3xl font-semibold">Terms and Conditions</h2>
      <p className="mb-6 text-gray-700">
        These Terms and Conditions govern your use of FlashQuote AI. By accessing or using our services, you agree to comply with these terms.
      </p>
      <h3 className="mt-6 mb-2 text-xl font-semibold">1. Acceptance of Terms</h3>
      <p className="text-gray-700">By using FlashQuote AI, you agree to these Terms and Conditions and our Privacy Policy.</p>
      <h3 className="mt-6 mb-2 text-xl font-semibold">2. User Accounts</h3>
      <ul className="list-disc pl-6 text-gray-700">
        <li>You must provide accurate information when creating an account.</li>
        <li>You are responsible for maintaining the confidentiality of your account credentials.</li>
        <li>Notify us immediately of any unauthorized use of your account.</li>
      </ul>
      <h3 className="mt-6 mb-2 text-xl font-semibold">3. Use of Services</h3>
      <ul className="list-disc pl-6 text-gray-700">
        <li>Do not use our services for unlawful or prohibited purposes.</li>
        <li>Do not attempt to disrupt or compromise the security of our platform.</li>
        <li>Respect intellectual property rights and do not copy, modify, or distribute content without permission.</li>
      </ul>
      <h3 className="mt-6 mb-2 text-xl font-semibold">4. Subscription and Payments</h3>
      <ul className="list-disc pl-6 text-gray-700">
        <li>Subscription plans and pricing are described on our website.</li>
        <li>Payments are processed securely through third-party providers.</li>
        <li>Failure to pay may result in suspension or termination of your account.</li>
      </ul>
      <h3 className="mt-6 mb-2 text-xl font-semibold">5. Termination</h3>
      <ul className="list-disc pl-6 text-gray-700">
        <li>We reserve the right to suspend or terminate your account for violation of these terms.</li>
        <li>You may terminate your account at any time by contacting us.</li>
      </ul>
      <h3 className="mt-6 mb-2 text-xl font-semibold">6. Limitation of Liability</h3>
      <p className="text-gray-700">FlashQuote AI is provided "as is". We are not liable for any damages arising from the use of our services.</p>
      <h3 className="mt-6 mb-2 text-xl font-semibold">7. Changes to Terms</h3>
      <p className="text-gray-700">We may update these Terms and Conditions periodically. Changes will be posted on this page with the updated date.</p>
      <h3 className="mt-6 mb-2 text-xl font-semibold">8. Contact Us</h3>
      <p className="text-gray-700">If you have questions about these Terms and Conditions, please contact us at flashquoteai@gmail.com.</p>
      <p className="mt-8 text-xs text-gray-500">Last updated: March 16, 2026</p>
    </div>
  );
}

export default TermsAndConditions;
